<template>
  <v-app>

    <v-main class="main-content">
      <v-container>
        <!-- Introducción -->
        <article class="intro"></article>
        <div class="marcas px-4 py-6 bg-gray-50">
          <div class="max-w-screen-xl mx-auto">
            <h2 class="text-3xl font-bold text-gray-800 mb-6">Promociones de Regalo</h2>

            <div class="flex overflow-x-auto space-x-5 pb-4">
              <div
                v-for="item in promoGifts"
                :key="item.id"
                class="min-w-[280px] max-w-sm bg-white rounded-2xl shadow-md border border-gray-200 flex-shrink-0 transition hover:shadow-xl"
              >
                <img
                  lazyloading
                  :src="item.foto"
                  alt="Imagen de promoción"
                  class="w-full h-48 object-cover rounded-t-2xl"
                />
                <div class="p-4">
                  <h3 class="text-xl font-semibold text-gray-800">{{ item.nombre }}</h3>
                  <p class="text-sm text-indigo-500 font-medium mb-1">{{ item.tipo }}</p>
                  <p class="text-sm text-gray-600 mb-2">{{ item.descripcion }}</p>
                  <p class="text-sm text-gray-700">
                    <strong>SKU:</strong> {{ item.sku_regalo }}
                  </p>
                  <p class="text-sm text-gray-700">
                    <strong>Cantidad:</strong> {{ item.cantidad }}
                  </p>
                  <p class="text-sm text-gray-700 mt-2">
                    <strong>Fecha:</strong> {{ formatDate(item.fecha_inicio) }} al
                    {{ formatDate(item.fecha_fin) }}
                  </p>
                </div>
                <div class="px-4 pb-4">
                  <button
                    @click="addGiftToCart(item)"
                    class="w-full bg-indigo-600 hover:bg-indigo-700 text-white font-semibold py-2 rounded-lg transition"
                  >
                    Agregar al carrito
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <CartDialog v-model="cartDialog" />
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import { inject, computed, ref } from "vue";
import CartDialog from "./Administrador/CarritoViewStore.vue"; // Asegúrate de que la ruta sea correcta
export default {
  name: "PromoView",
  components: {   CartDialog },
  setup() {
    const cartStore = inject("cartStore");
    const totalCajas = computed(() => {
      return cartStore.state.cart.reduce((total, item) => total + item.quantity, 0);
    });

    const snackbar = ref(false);
    const snackbarText = ref("");

    const addGiftToCart = async (item) => {
      await cartStore.addGiftToCart(item);
    };

    const addToCart2 = async (item) => {
      if (!cartStore) {
        console.error("cartStore no está disponible");
        return;
      }
      await cartStore.addToCart2(item);
      snackbarText.value = "Promoción agregada al carrito";
      snackbar.value = true;
    };

    const searchQuery = ref("");
    const promotions = ref([]);
    const promoGifts = ref([]);
    const cartDialog = ref(false);
    const cart = ref(JSON.parse(localStorage.getItem("cart")) || []);

    return {
      addGiftToCart,
      totalCajas,
      addToCart2,
      snackbar,
      snackbarText,
      searchQuery,
      promotions,
      promoGifts,
      cartDialog,
      cart,
    };
  },

  computed: {
    filteredPromotions() {
      return this.searchQuery
        ? this.promotions.filter((promo) =>
            promo.nombre.toLowerCase().includes(this.searchQuery.toLowerCase())
          )
        : this.promotions;
    },
  },
  methods: {
    formatDate(dateStr) {
      const options = { year: "numeric", month: "short", day: "numeric" };
      return new Date(dateStr).toLocaleDateString("es-MX", options);
    },



    async fetchPromoGifts() {
      const cacheKey = "promoGiftsCache2";
      const cacheTimeKey = cacheKey + "_time";
      const cache = localStorage.getItem(cacheKey);
      const cacheTime = localStorage.getItem(cacheTimeKey);
      const now = Date.now();

      const oneMinute = 1 * 60 * 1000;

      if (cache && cacheTime && now - cacheTime < oneMinute) {
        this.promoGifts = JSON.parse(cache);
        return;
      }
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          "https://mvexpress.mx/api/promo-gift",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        this.promoGifts = response.data;

        console.log("me obtuviste", this.promoGifts);
      } catch (err) {
        console.error("Error al cargar promociones de regalo:", err);
      }
    },

    openCart() {
      this.cartDialog = true;
    },



  },
  mounted() {
    this.fetchPromoGifts();
    const token = localStorage.getItem("token");
    if (!token) window.location.replace("/");
  },
};
</script>

<style scoped>
.promo-card {
  border: 2px solid rgb(18, 18, 3) !important;
  box-shadow: 0 4px 8px rgba(255, 0, 0, 0.5) !important;
}

.main-content {
  padding-bottom: 80px;
  background-size: cover;
  /* Asegura que la imagen cubra todo el fondo */
  background-position: center;
  /* Centra la imagen en el contenedor */
  background-repeat: no-repeat;
  /* Evita que la imagen se repita */
}

.fixed-bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

.v-dialog .v-card {
  background-color: #ffffff;
}

.v-row {
  margin-bottom: 10px;
}

intro {
  width: 100%;
  background: linear-gradient(to top, #3c006b, #9948d9);
  color: white;
  padding: 2rem 2rem 4rem 2rem;
}

.intro h1 {
  font-weight: 700;
  font-size: 2.5rem;
  line-height: 1.1;
  max-width: 18ch;
}

.intro p {
  font-size: 1.1rem;
  max-width: 50ch;
}

.intro a {
  font-weight: 700;
  font-size: 1.6rem;
  color: currentColor;
}

.intro {
  margin-top: 1.5em;
}

body {
  padding: 0;
}
</style>

<style scoped>
.horizontal-scroll {
  display: flex;
  overflow-x: auto;
  gap: 16px;
  /* Espacio entre tarjetas */
  padding-bottom: 10px;
  scroll-behavior: smooth;
}

.horizontal-scroll::-webkit-scrollbar {
  height: 8px;
}

.horizontal-scroll::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 4px;
}

.marcas {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  scroll-snap-type: x mandatory;
  gap: 15px;
  padding-bottom: 10px;
  scrollbar-width: none;
  /* Firefox */
  -ms-overflow-style: none;
  /* IE y Edge */
}

.actions-column {
  width: 150px;
  /* Ajusta el tamaño de la columna de acciones */
  text-align: center;
}

.fixed-cart-btn {
  position: fixed;
  bottom: 70px;
  /* Distancia desde el fondo, ajusta este valor para subir más o bajar el botón */
  left: 50%;
  transform: translateX(-50%);
  /* Centra el botón horizontalmente */
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 20px;
  border-radius: 50px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
  font-size: 16px;
}

.v-dialog__content {
  z-index: 9999;
  /* Asegura que el diálogo esté por encima del carrito */
}

.fixed-bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  padding: 10px;
}

.main-content {
  padding-bottom: 80px;
  /* Asegura que el contenido no quede tapado por el pie de página */
}

v-footer {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #f5f5f5;
  padding: 10px 0;
  text-align: center;
}
</style>
